// import EventActionCellHtml   from './templates/event.action-cell.html';
// import EventAssignedCellHtml from './templates/event.assigned-cell.html'

export function EventsListCtrl (
  $scope,
  $state,
  $stateParams,
  $translate,
  chartData,
  confirm,
  dateParsing,
  events,
  messages,
  workshopAPI
) {

  $scope.availableHours = chartData.days[0].available_hours;
  $scope.chartData      = chartData;
  $scope.date           = $stateParams.date;
  $scope.dateParsing    = dateParsing;
  $scope.events         = events;

  $scope.chartData = chartData;

  $scope.tableSettings = {
    columns: [
      {
        field : 'display_name',
        header: {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        }
      },
      {
        field : 'plate_number',
        header: {
          text: $translate.instant('VEHICLE_SPACE.VEHICLE')
        }
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('BOOKING_SPACE.JOB')
        }
      },
      {
        field : 'estimated_hours',
        header: {
          text: $translate.instant('BOOKING_SPACE.ESTIMATED_HOURS')
        }
      },
      {
        field : 'event_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        }
      }
    ],
    empty: {
      text: $translate.instant('BOOKING_SPACE.NO_BOOKINGS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/events/count', $scope.date)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getEvents = ( params ) => {
    return workshopAPI.get('/events', [
      $scope.date,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(events => {
      $scope.events = events;

      return events;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.event', {
      customer_id: event.row.customer_id,
      vehicle_id : event.row.vehicle_id,
      id         : event.row.id
    });
  };

  $scope.startJob = function (row) {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.START_JOB'))
    .then(() => workshopAPI.get('events/event_to_invoice', row.entity.id))
    .then(data => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.INVOICE'), 'success');

      $state.go('app.invoice', {
        customer_id: data.customer_id,
        vehicle_id : data.vehicle_id,
        id         : data.invoice_id
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };
}
